import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f87de73a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f87de73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87de73a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f87de73a')) {
      api.createRecord('f87de73a', component.options)
    } else {
      api.reload('f87de73a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f87de73a&scoped=true&", function () {
      api.rerender('f87de73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teammanagemant/studentList/index.vue"
export default component.exports